// frontend/src/components/ScientificAnalysis/ColumnTable.tsx

import React from 'react';

interface Props {
  columnsMetadata: any;
}

const renderValue = (value: any): React.ReactNode => {
  if (value === null || value === undefined) return '—';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const ColumnTable: React.FC<Props> = ({ columnsMetadata }) => {
  const items = Array.isArray(columnsMetadata) ? columnsMetadata : [];

  if (items.length === 0) {
    return (
      <div style={{ textAlign: 'center', color: '#8899aa', padding: '40px 0' }}>
        Nenhuma coluna encontrada
      </div>
    );
  }

  // Coleta todas as chaves possíveis (colunas dinâmicas)
  const allKeys = new Set<string>();
  for (const item of items) {
    for (const colName of Object.keys(item)) {
      const stats = item[colName];
      if (stats && typeof stats === 'object') {
        Object.keys(stats).forEach((k) => allKeys.add(k));
      }
    }
  }
  const statKeys = Array.from(allKeys);

  return (
    <div style={{
      background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
      borderRadius: '12px',
      border: '1px solid #1a4a7a',
      overflow: 'hidden',
      overflowX: 'auto',
      marginBottom: '24px'
    }}>
      <h4 style={{ padding: '16px 20px 0 20px', margin: 0, color: '#4fc3f7' }}>
        📊 Colunas (columns_metadata)
      </h4>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
        <thead style={{ background: 'rgba(15, 42, 74, 0.6)' }}>
          <tr>
            <th style={{ padding: '12px 16px', textAlign: 'left', color: '#8899aa', fontWeight: 600, fontSize: '12px' }}>Coluna</th>
            {statKeys.map((k) => (
              <th key={k} style={{ padding: '12px 16px', textAlign: 'left', color: '#8899aa', fontWeight: 600, fontSize: '12px' }}>{k}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            const colName = Object.keys(item)[0];
            const stats = item[colName] || {};
            return (
              <tr
                key={index}
                style={{ borderTop: '1px solid rgba(26, 74, 122, 0.3)' }}
              >
                <td style={{ padding: '10px 16px', color: '#e0e0e0', fontWeight: 500 }}>{colName}</td>
                {statKeys.map((k) => (
                  <td key={k} style={{ padding: '10px 16px', color: '#e0e0e0' }}>
                    {renderValue(stats[k])}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};